import { readCachedAppSession } from './session-cache';

let testMemberIdOverride: string | null = null;

/** Unit tests inject the seeded offline fixture member. */
export function __testOnlySetCurrentMemberId(memberId: string | null): void {
  testMemberIdOverride = memberId;
}

/** Member id for local DB reads and sidebar — never "first row in members". */
export function getCurrentMemberId(): string | null {
  if (testMemberIdOverride) {
    return testMemberIdOverride;
  }
  const cached = readCachedAppSession();
  if (cached?.id) {
    return cached.id;
  }
  return null;
}
